import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import lang from '@/assets/scripts/i18n/index'
import axios from './api'
import kmUI from '@/ui'
import store from '@/store'
import showToast from '@/ui/components/Toast/index'
import queueUp from '@/components/queueUp'

import { Message, Popover } from 'element-ui'
Message.install = function (Vue, options) {
  Vue.prototype.$message = Message
}
Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(axios)
Vue.use(kmUI)
Vue.use(store)
Vue.use(Message)
Vue.use(Popover)
Vue.use(queueUp)

Vue.prototype.$toast = showToast

const i18n = new VueI18n({
  locale: 'zh',
  messages: lang
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js